import {
  WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_CLOSE,
  WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_SHOW,
} from '../action-types';
import { closeProposalApprovalModal } from 'actions/admin/work-orders/details/proposal-approval';
import {
  loadWorkOrderRequest,
  selectNavigationBar,
  updateProposal,
} from 'actions/admin/work-orders/details/details';
import { showErrorMessage } from 'actions/messages';
import { proposalsApi } from 'services/api/proposals-api';

export function closeDeclineProposalModal() {
  return {
    type: WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_CLOSE,
  };
}

export function declineProposalRequest(
  currentWorkOrderId,
  proposalId,
  password,
  reason1,
  reason2
) {
  return (dispatch) => {
    return proposalsApi
      .reject(proposalId, password, reason1, reason2)
      .then((response) => {
        if (response.ok) {
          dispatch(updateProposal(response.proposal));
          dispatch(closeDeclineProposalModal());
          dispatch(closeProposalApprovalModal());
          dispatch(loadWorkOrderRequest(currentWorkOrderId, true, false));
          dispatch(selectNavigationBar(currentWorkOrderId, 1));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function showDeclineProposalModal() {
  return {
    type: WORK_ORDERS_DETAILS_DECLINE_PROPOSAL_MODAL_SHOW,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/details/decline-proposal.js